import { Component } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-admin-tabs',
  template: `
    <app-tabs
      [links]="[
        {
          label: 'Données administratives',
          routerLink: '/administration/donnees',
          icon: 'file-pen',
        },
        {
          label: 'Paiement en ligne',
          routerLink: '/administration/paiement-en-ligne',
          icon: 'credit-card',
        },
      ]"
    ></app-tabs>
  `,
  imports: [SharedModule],
  standalone: true,
})
export class AdminTabsComponent {}
